import { Hero } from '../components/Hero';
import { Products } from '../components/Products';
import { About } from '../components/About';

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <Products />
      <About />
    </main>
  );
};
